<template>
  <ApiTokensBox
    :has-borders="false"
    :has-empty-message="false"
    :limit="2"
    size="lg"
  />
</template>
